import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

const ServiceOffer = () => {
  const { t, routes } = useI18n();
  return (
    <section id="devis" className="bg-slate-50 border-y border-slate-200 scroll-mt-20" data-testid="service-offer-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 section">
        <div className="grid lg:grid-cols-[1fr_420px] gap-10 lg:gap-16 items-start">
          <div className="max-w-2xl">
            <span className="accent-bar" />
            <p className="eyebrow mb-3">{t.serviceOffer.eyebrow}</p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              {t.serviceOffer.title}
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">{t.serviceOffer.lead}</p>
          </div>

          <div className="card p-7 bg-white" data-testid="service-offer-card">
            <h3 className="font-display font-bold text-2xl tracking-tight">
              {t.serviceOffer.cardTitle}
            </h3>
            <ul className="mt-6 space-y-3">
              {t.serviceOffer.items.map((it, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                  <Check size={16} className="text-[#016C36] mt-0.5 shrink-0" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
            <Link to={routes.quote} className="btn-primary w-full mt-7" data-testid="service-offer-cta">
              {t.serviceOffer.cta} <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceOffer;
